/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { clickTrack } from '@/utils/analytics/clickTrack';

export function trackLinkFromCertonaCartridge(productLinkName: string) {
  const { pageName = '', pageType = '', siteSection = '' } = window.utag_data ?? {};
  clickTrack({
    eventType: 'miniCart_certona',
    pageName,
    pageType,
    productLinkName: productLinkName,
    siteSection,
    customLinkName: 'miniCart-Certona_Clicks',
  });
}
